import { render, staticRenderFns } from "./ShiftSummary.vue?vue&type=template&id=fb33aea2&"
import script from "./ShiftSummary.vue?vue&type=script&lang=js&"
export * from "./ShiftSummary.vue?vue&type=script&lang=js&"
import style0 from "./ShiftSummary.vue?vue&type=style&index=0&id=fb33aea2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports